export default __webpack_public_path__ + "static/media/honey15.7ce84ee6.png";